import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useGetContainerTypes } from '@/services/apis/queries/container-types/use-get-container-types';
import type { LotSizingCriteria } from '@/types/core/lot-sizing/lot-sizing-criteria';
import { LotSizingSizingMethod } from '@/types/core/lot-sizing/lot-sizing-sizing-method';

export const useCriteriaOptions = () => {
  const { t } = useTranslation(['lotSizing']);

  const { data: containerTypes } = useGetContainerTypes();

  const criteriaTypeOptions = useMemo(
    () => [{ label: t('lotSizing:volume'), value: 'volume' }],
    [t],
  );

  const getContainerSelection = useCallback(
    (
      criteria: LotSizingCriteria,
    ): { value: string; options: { label: string; value: string }[] } => {
      const value =
        criteria.sizingMethod === LotSizingSizingMethod.PERSONALISED ||
        criteria.containerId === null
          ? LotSizingSizingMethod.PERSONALISED
          : String(criteria.containerId);

      if (value === LotSizingSizingMethod.PERSONALISED) {
        return {
          value,
          options: [{ label: t('lotSizing:personalised'), value }],
        };
      }

      const containerType = (containerTypes ?? []).find(
        (container) => String(container.id) === value,
      );
      const label = containerType?.name ?? '';

      return {
        value,
        options: [{ label, value }],
      };
    },
    [containerTypes, t],
  );

  return {
    criteriaTypeOptions,
    getContainerSelection,
  };
};
